import React, { useEffect, createElement } from 'react';
import { StickyOfferBar } from './components/StickyOfferBar';
import { ProductShowcase } from './components/ProductShowcase';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Transformation } from './components/Transformation';
import { Plan } from './components/Plan';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { FAQ } from './components/FAQ';
import { Closing } from './components/Closing';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      f.fbq('init', '999348842752724');
      f.fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-white font-opensans selection:bg-coral selection:text-white" data-id="element-0">
      <StickyOfferBar data-id="element-1" />
      <Hero data-id="element-2" />
      <Problem data-id="element-3" />
      <ProductShowcase data-id="element-4" />
      <Solution data-id="element-5" />
      <Transformation data-id="element-6" />
      <Plan data-id="element-7" />
      <Bonuses data-id="element-8" />
      <ProductShowcase data-id="element-9" />
      <FAQ data-id="element-10" />
      <Closing data-id="element-11" />
      <SocialProofPopup data-id="element-12" />
    </div>;
}